/* v60-c.js – prima pagină, colecții, căutare, coș.
   Filtre/sortare/pagini fără reîncărcare (view=ajax), „Încarcă mai multe”, rânduri de produse cu file (view=row), pagina coșului (view=page),
   scripturi amânate (type="v60/late" după încărcare, type="v60/view" când ajung aproape de ecran). */
(function () {
  'use strict';
  var U = window.V60U || function (u) { return u; };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function withView(u, v) { var x = new URL(u, location.href); x.searchParams.set('view', v); x.searchParams.delete('preview_theme_id'); return U(x.pathname + x.search); }
  function get(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }); }
  function ev(n, d) { document.dispatchEvent(new CustomEvent(n, { detail: d })); }
  var io = 'IntersectionObserver' in window ? function (el, fn, m) { var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { o.disconnect(); fn(); } }); }, { rootMargin: m || '700px' }); o.observe(el); } : function (el, fn) { fn(); };

  /* ───── scripturi amânate ───── */
  function run(s) { var n = document.createElement('script'); n.textContent = s.textContent; s.replaceWith(n); }
  var lateDone = false;
  function late() { if (lateDone) return; lateDone = true; $$('script[type="v60/late"]').forEach(run); }
  if (document.readyState === 'complete') setTimeout(late, 2500); else addEventListener('load', function () { setTimeout(late, 2500); });
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (t) { addEventListener(t, late, { once: true, passive: true }); });
  $$('script[type="v60/view"]').forEach(function (s) { io(s.parentNode, function () { run(s); }, '500px'); });

  /* ───── descrierea colecției: „Citește mai mult” ───── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cp-more]'); if (!b) return;
    var d = document.getElementById(b.getAttribute('aria-controls')); if (!d) return;
    var open = d.classList.toggle('is-clamp') === false; b.setAttribute('aria-expanded', open); b.textContent = open ? 'Citește mai puțin' : 'Citește mai mult';
  });

  /* ───── filtre / sortare / pagini ───── */
  if ($('[data-cm]')) {
    var ctl = null, html = document.documentElement;
    var openFF = function () { html.classList.add('ff-open'); html.style.overflow = 'hidden'; };
    var closeFF = function () { html.classList.remove('ff-open'); html.style.overflow = ''; };
    var formUrl = function (f) {
      var p = new URLSearchParams(); new FormData(f).forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var s = p.toString(); return f.getAttribute('action') + (s ? '?' + s : '');
    };
    var load = function (url, push) {
      try { var cu = new URL(url, location.href); cu.searchParams.delete('view'); cu.searchParams.delete('preview_theme_id'); url = cu.pathname + cu.search; } catch (_) {}
      if (ctl) try { ctl.abort(); } catch (_) {}
      ctl = window.AbortController ? new AbortController() : null;
      var cur = $('[data-cm]'); cur.classList.add('is-busy');
      var keep = $$('.ff__f[open]', cur).map(function (d) { return d.getAttribute('data-key'); });
      var all = $$('.ff__f.is-all', cur).map(function (d) { return d.getAttribute('data-key'); });
      return fetch(withView(url, 'ajax'), { credentials: 'same-origin', signal: ctl && ctl.signal }).then(function (r) { return r.text(); }).then(function (h) {
        var t = document.createElement('div'); t.innerHTML = h; var n = $('[data-cm]', t);
        if (!n || /<html/i.test(h)) { location.href = url; return; }
        $('[data-cm]').replaceWith(n);
        keep.forEach(function (k) { var d = $('.ff__f[data-key="' + k + '"]', n); if (d) d.open = true; });
        all.forEach(function (k) { var d = $('.ff__f[data-key="' + k + '"]', n); if (d) { d.classList.add('is-all'); var m = $('[data-ff-more]', d); if (m) m.remove(); } });
        if (push) history.pushState({ v60c: 1 }, '', url);
        if (window.msdEtaFill) window.msdEtaFill(n);
        ev('v60:grid', n);
      }).catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; })
        .finally(function () { var c = $('[data-cm]'); if (c) c.classList.remove('is-busy'); });
    };
    var more = function (btn) {
      if (btn.getAttribute('aria-busy')) return; btn.setAttribute('aria-busy', 'true'); var lbl = btn.textContent; btn.textContent = 'Se încarcă…';
      get(withView(btn.href, 'ajax')).then(function (h) {
        var t = document.createElement('div'); t.innerHTML = h;
        var g = $('[data-grid]', t), cur = $('[data-cm] [data-grid]');
        if (!g || !cur) { location.href = btn.href; return; }
        $$(':scope > li', g).forEach(function (li) { if (li.querySelector('.msd-card--soldout')) { cur.appendChild(li); return; } var firstOut = $$(':scope > li', cur).filter(function (x) { return x.querySelector('.msd-card--soldout'); })[0]; cur.insertBefore(li, firstOut || null); }); /* epuizatele rămân mereu la final */
        var nav = $('.pgn', t), old = $('[data-cm] .pgn'); var tot0 = old && $('.pgn__info', old) ? +$('.pgn__info', old).getAttribute('data-total') : 0; if (old) { if (nav) old.replaceWith(nav); else old.remove(); }
        var info = $('[data-cm] .pgn__info'); if (info) { var tot = Math.max(tot0, +info.getAttribute('data-total')); info.setAttribute('data-total', tot); info.textContent = 'Se arată ' + cur.children.length + ' din ' + tot + ' produse'; }
        ev('v60:grid', cur);
      }).catch(function () { location.href = btn.href; }).finally(function () { btn.removeAttribute('aria-busy'); btn.textContent = lbl; });
    };
    document.addEventListener('change', function (e) {
      var f = e.target.form; if (!f || !f.matches('[data-ff]')) return;
      load(formUrl(f), true);
    });
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches('[data-ff]')) return;
      e.preventDefault(); var u = formUrl(f); closeFF();
      if (u !== location.pathname + location.search) load(u, true);
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ff-link]');
      if (a && a.closest('[data-cm]')) {
        e.preventDefault(); var pg = !!a.closest('.pgn'); closeFF();
        load(a.href, true).then(function () { if (pg) { var c = $('[data-cm]'); scrollTo({ top: c.getBoundingClientRect().top + scrollY - 90, behavior: 'smooth' }); } });
        return;
      }
      var m = e.target.closest('[data-more]'); if (m) { e.preventDefault(); more(m); return; }
      if (e.target.closest('[data-ff-open]')) { openFF(); return; }
      if (e.target.closest('[data-ff-close]')) { closeFF(); return; }
      var sm = e.target.closest('[data-ff-more]'); if (sm) { sm.closest('.ff__f').classList.add('is-all'); sm.remove(); return; }
      if (matchMedia('(min-width:1025px)').matches) $$('.ff__f[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('toggle', function (e) {
      var d = e.target; if (!d.matches || !d.matches('.ff__f') || !d.open || !matchMedia('(min-width:1025px)').matches) return;
      $$('.ff__f[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeFF(); $$('.ff__f[open]').forEach(function (d) { if (matchMedia('(min-width:1025px)').matches) d.open = false; }); } });
    addEventListener('popstate', function () { load(location.href, false); });
  }

  /* ───── rânduri de produse cu file (prima pagină, căutare fără rezultate) ───── */
  var cache = {};
  function row(ul, h) {
    ul.setAttribute('data-hr', h);
    if (cache[h]) { ul.innerHTML = cache[h]; ul.scrollLeft = 0; return; }
    ul.setAttribute('aria-busy', 'true');
    get(U('/collections/' + h + '?view=row')).then(function (t) {
      if (/<html/i.test(t)) return; cache[h] = t;
      if (ul.getAttribute('data-hr') === h) { ul.innerHTML = t; ul.scrollLeft = 0; ev('v60:grid', ul); }
    }).catch(function () {}).finally(function () { ul.removeAttribute('aria-busy'); });
  }
  $$('[data-hs]').forEach(function (s) {
    var ul = $('.hr', s);
    if (ul.hasAttribute('data-lazy')) io(s, function () { row(ul, ul.getAttribute('data-hr')); });
    else cache[ul.getAttribute('data-hr')] = ul.innerHTML;
    s.addEventListener('click', function (e) {
      var t = e.target.closest('.hs__t');
      if (t) {
        $$('.hs__t', s).forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
        var h = t.getAttribute('data-h'); row(ul, h); var all = $('[data-hs-all]', s); if (all) all.href = '/collections/' + h;
        return;
      }
      var a = e.target.closest('[data-hs-ar]');
      if (a) ul.scrollBy({ left: +a.getAttribute('data-hs-ar') * ul.clientWidth * 0.9, behavior: 'smooth' });
    });
  });

  /* ───── pagina coșului ───── */
  var cp = $('[data-cartpage]');
  if (cp) {
    var R = window.V60 || {};
    var refresh = function () {
      return get(U((R.cart || '/cart') + '?view=page')).then(function (h) {
        if (/<html/i.test(h)) { location.reload(); return; }
        cp.innerHTML = h;
        try { var m = JSON.parse(($('[data-cart-meta]', cp) || {}).textContent || '{}'); if ('count' in m && window.V60Cart) window.V60Cart.setCount(m.count); } catch (_) {}
        if (window.msdEtaFill) window.msdEtaFill(cp);
      });
    };
    cp.addEventListener('click', function (e) {
      var q = e.target.closest('[data-q]'); if (!q) return;
      var it = q.closest('[data-key]'); cp.classList.add('is-busy');
      fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.getAttribute('data-key'), quantity: +q.getAttribute('data-q') }) })
        .then(refresh).finally(function () { cp.classList.remove('is-busy'); });
    });
    cp.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-note]')) return;
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    });
    document.addEventListener('cart:added', function () { setTimeout(refresh, 300); });
    document.addEventListener('click', function (e) { if (e.target.closest('#cart-drawer [data-q], #cart-drawer [data-cart-close]')) setTimeout(refresh, 600); });
  }
})();
